/**
 * The void rule for claim closeout, kept separate from `closeout-form.tsx` so it is
 * testable. The form imports the `base` barrel (emotion, MUI) and `../../../api`,
 * which re-exports the whole generated client — importing it from a unit test would
 * exercise module resolution rather than this rule. `ClaimCloseoutType` is therefore
 * taken from its own generated model file, not the `api` barrel, leaving this module
 * with an empty transitive import graph.
 *
 * A void is not a status change: it tells the payer to disregard a submitted claim,
 * and it cannot be walked back. `voidLocked` is what enforces that — see below.
 */
import { ClaimCloseoutType } from '../../../api/server/models/ClaimCloseoutType';

export const VOID_CLAIM_HELPER =
    'Sends a void to the payer when the payer is ready, similar to a replacement. A voided claim cannot be reopened.';

/**
 * Once a claim is voided, updates must keep closeoutVoid true. Otherwise only
 * CLOSED + checked is a void.
 */
export const resolveCloseoutVoid = (
    closeoutType: ClaimCloseoutType,
    closeoutVoid: boolean | undefined,
    voidLocked?: boolean,
): boolean => {
    if (voidLocked) {
        return true;
    }
    return closeoutType === ClaimCloseoutType.CLOSED && !!closeoutVoid;
};
